import { IOnInit } from "angular";
import { IFieldArray } from "AngularFormly";
import {
  FieldConfigurationHelperService,
  vsName as FieldConfigurationHelperServiceName,
} from "../../../../records/forms/formly/fieldConfigurationHelpers";
import fieldHelpers from "../../../../ui-formly/fieldHelpers";
import { FormViewController } from "../../../../records/forms/formView";
import { LookupManagementService } from "../../../../records/lookup/lookupManagement";
import { vsLookupManagementServiceName as MachineLookupManagementServiceName } from "../../../shared/lookups";
import { conversionTypeName } from "../../configs/lookup";

interface Options {
  CreateConversionForAssociatedMachines: boolean;
  MachineConversionTypeId: number | undefined;
  Notes: string;
  Date: Date;
  ChangeJournalNote: string;
}

export class MachineConfigurationTypeSubmitOptionsModalServiceComponentController
  implements IOnInit
{
  static $inject = [
    FieldConfigurationHelperServiceName,
    "$element",
    MachineLookupManagementServiceName,
  ];

  private readonly modalInstance!: angular.ui.bootstrap.IModalInstanceService;
  private readonly model: Options = {
    CreateConversionForAssociatedMachines: false,
    MachineConversionTypeId: undefined,
    Notes: "",
    Date: new Date(),
    ChangeJournalNote: "",
  };
  private readonly formFields: IFieldArray;
  constructor(
    fieldConfigurationHelperService: FieldConfigurationHelperService,
    private readonly $element: angular.IAugmentedJQuery,
    machineLookupManagementService: LookupManagementService
  ) {
    this.formFields = [
      fieldHelpers.textAreaField({
        rows: 5,
        key: "ChangeJournalNote",
        label: "Change Note",
        required: true,
      }),
      fieldHelpers.simpleBoolField({
        key: "CreateConversionForAssociatedMachines",
        label: "Create Conversion for Associated Machines",
        defaultValue: false,
      }),
      {
        fieldGroup: [
          fieldHelpers.simpleDateField({
            key: "Date",
            label: "Date",
            required: true,
          }),
          fieldConfigurationHelperService.lookupField(
            machineLookupManagementService,
            {
              key: "MachineConversionTypeId",
              label: "Conversion Type",
              objectName: conversionTypeName,
            }
          ),
          fieldHelpers.textAreaField({
            key: "Notes",
            label: "Notes",
            rows: 5,
          }),
        ],
        hideExpression: "!model.CreateConversionForAssociatedMachines",
      },
    ];
  }

  $onInit(): void {
    this.$element.parent().css("width", "900px");
  }

  submit() {
    this.modalInstance.close(this.model);
    return this.modalInstance.result;
  }
}
